import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'

export default function PopoverMenu({ buttonText, items, sections, className = '' }) {
    return (
        <Popover>
            <PopoverButton
                className={`block text-gray-700 focus:outline-none data-[active]:text-gray-900 data-[hover]:text-gray-900 ${className}`}
            >
                {buttonText}
            </PopoverButton>
            <PopoverPanel
                transition
                anchor='bottom'
                className='rounded-xl bg-white shadow-lg ring-1 ring-gray-200 text-sm text-gray-800 transition duration-200 ease-in-out [--anchor-gap:1rem] data-[closed]:-translate-y-1 data-[closed]:opacity-0'
            >
                {items.length > 0 && (
                    <div className='p-3'>
                        {items.map((item, index) => (
                            <a
                                key={index}
                                className='block px-3 py-2 transition rounded-lg hover:bg-yellow-50'
                                href={item.href}
                            >
                                <p className='font-semibold text-gray-800'>{item.title}</p>
                                {item.description && (
                                    <p className='text-sm text-gray-500'>{item.description}</p>
                                )}
                            </a>
                        ))}
                    </div>
                )}

                {sections?.map((section, sectionIndex) => (
                    <div key={sectionIndex} className='p-3 border-t border-gray-200'>
                        {section.map((item, itemIndex) => (
                            <a
                                key={itemIndex}
                                className='block px-3 py-2 transition rounded-lg hover:bg-yellow-50'
                                href={item.href}
                            >
                                <p className='font-semibold text-gray-800'>{item.title}</p>
                                {item.description && (
                                    <p className='text-sm text-gray-500'>{item.description}</p>
                                )}
                            </a>
                        ))}
                    </div>
                ))}
            </PopoverPanel>
        </Popover>
    )
}
